import React, { useCallback, useEffect, useState } from 'react';
import Axios from 'axios';

export const MailCountsContext = React.createContext({
    unread: 0,
    loading: false,
    refetch: () => {},
    updateUnread: () => {},
});

export function MailCountsProvider({ children }) {
    const [counts, setCounts] = useState({
        unread: 0,
    });
    const [loading, setLoading] = useState(false);

    const refetch = useCallback(async () => {
        try {
            setLoading(true);
            const res = await Axios.get('/api/mail-unread-count');
            const data = res?.data?.data || {};
            setCounts(prev => ({
                ...prev,
                unread: data.unread || 0,
            }));
        } catch (err) {
            // Silently ignore count errors so the rest of the app keeps working
        } finally {
            setLoading(false);
        }
    }, []);

    const updateUnread = useCallback((unread) => {
        setCounts(prev => ({ ...prev, unread: unread || 0 }));
    }, []);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return (
        <MailCountsContext.Provider value={{ ...counts, loading, refetch, updateUnread }}>
            {children}
        </MailCountsContext.Provider>
    );
}
